export const visibleRestoreModal = {
  value: true,
};
